import React from 'react';

const Logo = () => (
    <div className="flex items-center justify-center">
        <svg width="200" height="40" viewBox="0 0 200 40" xmlns="http://www.w3.org/2000/svg">
            <style>
                {`
                .logo-path-line {
                    stroke-dasharray: 230;
                    stroke-dashoffset: 230;
                    animation: draw-line 2s 0.5s ease-in-out forwards;
                }
                .logo-text, .logo-shapes {
                    opacity: 0;
                    animation: fade-in 1s ease-in-out forwards;
                }
                .logo-text { animation-delay: 0s; }
                .logo-shapes { animation-delay: 1.5s; }

                @keyframes draw-line {
                    to { stroke-dashoffset: 0; }
                }
                @keyframes fade-in {
                    to { opacity: 1; }
                }
                `}
            </style>
            
            <g className="logo-text">
                <text x="25" y="22" fontFamily="serif" fontSize="24" fill="currentColor" className="text-gray-800 dark:text-gray-200">
                    Plan
                </text>
                <text x="82" y="22" fontFamily="sans-serif" fontSize="24" fontWeight="600" fill="currentColor" className="text-blue-600">
                    Master
                </text>
            </g>

            <g transform="translate(15, 7)" stroke="currentColor" fill="none" strokeWidth="1">
                <path d="M0,25 H60 L70,18 L80,28 L90,18 L100,25 H170" className="logo-path-line text-gray-400" />
                <g className="logo-shapes" fill="currentColor" stroke="none">
                    <circle cx="60" cy="25" r="2.5" className="text-gray-400"/>
                    <rect x="78" y="26" width="4" height="4" className="text-gray-400"/>
                    <circle cx="90" cy="18" r="2.5" className="text-gray-400"/>
                    <path d="M170,25 l5,-3 v6 Z" className="text-gray-400"/>
                </g>
            </g>
        </svg>
    </div>
);

export default Logo;
